module.exports = __webpack_public_path__ + "assets/reorder-arrow-down-085dda.svg";